import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/product-detail1',
    name: 'productDetail1',
    component: () => import('@/views/productDetail1.vue')
  },
  {
    path: '/product-detail',
    name: 'productDetail',
    component: () => import('@/views/productDetail.vue')
  },
  {
    path: '/article-detail',
    name: 'articleDetail',
    component: () => import('@/views/articleDetail.vue')
  },
  {
    path: '/dynamic-list',
    name: 'dynamicList',
    component: () => import('@/views/dynamicList.vue')
  },
  {
    path: '/tech-list',
    name: 'techList',
    component: () => import('@/views/techList.vue')
  },
  {
    path: '/tech-detail',
    name: 'techDetail',
    component: () => import('@/views/techDetail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
